/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { DocumentsControllerGetDownloadUrlQueryResponse, DocumentsControllerGetDownloadUrlPathParams, DocumentsControllerGetDownloadUrlQueryParams } from "../../models/documentsController/DocumentsControllerGetDownloadUrl";

function getDocumentsControllerGetDownloadUrlUrl(id: DocumentsControllerGetDownloadUrlPathParams["id"]) {
  const res = { method: 'GET', url: `/api/v1/documents/${id}/download-url` as const }  
  return res
}

/**
 * @description Generates a presigned URL for direct S3 download of the document PDF. Uses the document storageLocation to find the file. Set inline=true to display in browser instead of forcing download.
 * @summary Get presigned download URL for a document
 * {@link /api/v1/documents/:id/download-url}
 */
export async function documentsControllerGetDownloadUrl(id: DocumentsControllerGetDownloadUrlPathParams["id"], params?: DocumentsControllerGetDownloadUrlQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<DocumentsControllerGetDownloadUrlQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getDocumentsControllerGetDownloadUrlUrl(id).url.toString(), params, ... requestConfig })  
  return res.data
}